<template>
    <div class="course-catalogue-popup-content">
        <div class="course-catalogue-popup-title">
            <div class="course-catalogue-popup-side">
                <span class="title-back" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </span>
            </div>
            <div class="course-catalogue-popup-mid">
                <span>课程目录</span>
            </div>
            <div class="course-catalogue-popup-side"></div>
        </div>
        <div class="course-catalogue-pp-list">
            <div v-for="tData in curCourseTableList" :key="'course-cc-'+tData.id" class="course-catalogue-pp-item" @click="clickItem(tData)">
                <div class="course-cpp-item-title" :class="tData.id == curCourseDetailInfo.id ? 'cur' : ''">{{ tData.f_title }}</div>
                <div class="course-cpp-item-info">{{ tData.f_percentage == 100 ? '已学完' : tData.f_percentage == 0 ? '未开始' : '已学'+tData.f_percentage+'%' }}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { UA, UTILS } from '../../modules/utils';
import { COMMENT_DOM, FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'CourseCataloguePopup',
    computed: {
        curCourseDetailInfo() {
            return this.$store.state.course.curCourseDetailInfo;
        },
        curCourseTableList() {
            return this.$store.state.course.curCourseTableList;
        }
    },
    props: {
        textValue: {
            type: String,
            default() { return '' }
        }
    },
    data() {
        return {
            locked: false
        }
    },
    mounted: function() {
    },
    methods: {
        clickBack() {
            this.$store.state.course.showCataloguePopup = false;
        },
        clickItem(tData) {
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, 1000);
            let curCourseDetailInfo = this.$store.state.course.curCourseDetailInfo;
            if(tData.id == curCourseDetailInfo.id) {
                return;
            }
            console.log('clickItem-----', tData.f_cid, tData.id, curCourseDetailInfo.id)
            // return;

            this.$store.dispatch('course/resetCourseVideoInfo');
            this.$store.dispatch('course/getCourseDetailInfo', {
                dId: tData.id,
                sucCb: () => {
                    this.$store.state.course.showCataloguePopup = false;
                    this.$router.replace('/course/coursedetail-'+tData.f_cid+'/'+tData.id);
                    this.$bus.emit('replayCourseVideo');
                }
            });
        }
    }
}
</script>